import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';
@Api('api/app/version')
export class VersionInfoDto extends DtoHasApi {
  version: string;
  updateDate: string;
  uiVersion: string;
  uiUpdateDate: string;
}
